import $ from 'jquery'
import 'inputmask/dist/jquery.inputmask.js'

export default {
  name: 'masked-input',
  props: ['options', 'value'],
  mounted: function () {
    var vm = this
    $(this.$el)
      .inputmask(this.options)
      .val(this.value)
      .on('change', function () {
        if (this.options?.alias === 'email' && this.value[this.value.length - 1] === '.' && this.value.length > 2) {
          this.value = this.value.slice(0, this.value.length - 2)
        }
        vm.$emit('input', this.value)
      })
  },
  watch: {
    value: function (value) {
      // update value
      $(this.$el)
        .val(value)
        .trigger('change')
    },
    options: function (options) {
      // update options
      $(this.$el)
        .empty()
        .inputmask(this.options)
    }
  },
  destroyed: function () {
    $(this.$el)
      .off()
      .inputmask('remove')
  }
}
